import * as React from "react"

import { cva } from "class-variance-authority"

import { cn } from "@/src/lib/utils"

import type { VariantProps } from "class-variance-authority"

const badgeVariants = cva(
  "inline-flex w-fit shrink-0 items-center justify-center gap-1 rounded-md border px-2 py-0.5 text-xs font-medium whitespace-nowrap [&>svg]:pointer-events-none [&>svg]:size-3",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        destructive: "border-transparent bg-destructive text-white",
        outline: "text-foreground",
        success:
          "border-status-active/30 bg-status-active/10 text-status-active",
        warning:
          "border-status-warning/30 bg-status-warning/10 text-status-warning",
        error: "border-status-error/30 bg-status-error/10 text-status-error",
        neutral:
          "border-status-neutral/40 bg-status-neutral/10 text-muted-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}: React.ComponentProps<"span"> & VariantProps<typeof badgeVariants>) {
  return (
    <span
      className={cn(badgeVariants({ variant }), className)}
      data-slot="badge"
      {...props}
    />
  )
}

export { Badge, badgeVariants }
